import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { WalletProviderType } from '../auth/providers/activeProvider';

interface WalletState {
  address: string | null;
  isConnected: boolean;
  isConnecting: boolean;
  error: string | null;
  providerType: WalletProviderType | null;
  walletConnectUri: string | null;
}

export const WALLET_CONNECTED_KEY = 'wallet_connected';
export const WALLET_PROVIDER_KEY = 'wallet_provider';

const initialState: WalletState = {
  address: null,
  isConnected: false,
  isConnecting: false,
  error: null,
  providerType: null,
  walletConnectUri: null,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setConnecting: (state, action: PayloadAction<boolean>) => {
      state.isConnecting = action.payload;
      state.error = null;
    },
    setConnected: (
      state,
      action: PayloadAction<{ address: string; providerType: WalletProviderType }>
    ) => {
      state.address = action.payload.address;
      state.isConnected = true;
      state.isConnecting = false;
      state.error = null;
      state.providerType = action.payload.providerType;
      state.walletConnectUri = null;
      try {
        localStorage.setItem(WALLET_CONNECTED_KEY, 'true');
        localStorage.setItem(WALLET_PROVIDER_KEY, action.payload.providerType);
      } catch (error) {
        console.error('Failed to save wallet connection status to localStorage:', error);
      }
    },
    setDisconnected: (state) => {
      state.address = null;
      state.isConnected = false;
      state.isConnecting = false;
      state.error = null;
      state.providerType = null;
      state.walletConnectUri = null;
      try {
        localStorage.removeItem(WALLET_CONNECTED_KEY);
        localStorage.removeItem(WALLET_PROVIDER_KEY);
      } catch (error) {
        console.error('Failed to remove wallet connection status from localStorage:', error);
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnecting = false;
    },
    setWalletConnectUri: (state, action: PayloadAction<string | null>) => {
      state.walletConnectUri = action.payload;
    },
  },
});

export const { setConnecting, setConnected, setDisconnected, setError, setWalletConnectUri } =
  walletSlice.actions;
export default walletSlice.reducer;
